import { country_code } from './../site-lang';
import {get_cookie} from '../cookies/crumblr';

// Drift Campaign IDs (based on locale)
const drift_campaign_ids = {
  en: 2303778,
  de: 2302373,
  es: 2303779,
  fr: 2303780,
};

export default function run_drift_fast_lane(el_form, response_obj) {

  const geo_loc                = get_cookie('bw_geo');
  const drift_fastlane_enabled = el_form.hasAttribute('data-drift-fastlane');

  let campaign_id = drift_campaign_ids[country_code()];
  
  if (country_code() === 'en' && (geo_loc === 'US' || geo_loc === 'CA')) {
    // If current site is .com/en site AND geo location is
    // USA or Canada, load USA playbook
    campaign_id = 2269717;
  }

  const proceed = (
    drift_fastlane_enabled &&
    typeof drift === 'function' &&
    campaign_id
  );

  if (!proceed) {
    return;
  }

  const redirect = response_obj.followup_actions.get_redirect();
  response_obj.followup_actions.prevent_all = true;

  console.log('Drift Campaign ID: ', campaign_id);

  drift('collectFormData', el_form, {
    campaignId: campaign_id,
    mapFields: true,
    followupUrl: redirect,
  });
};

